import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {MatSort} from '@angular/material/sort';
import { MatCell, MatCellDef, MatColumnDef, MatHeaderCell, MatHeaderCellDef, MatHeaderRow,
  MatHeaderRowDef, MatRow, MatRowDef, MatTable, MatTableDataSource} from '@angular/material/table';
import {ImageWithDriverAndVehicle} from '../../../../../shared/models/image';
import {InfiniteScroll} from '../../../../../shared/tools/InfiniteScrollTools';
import {InsightsRoute} from '../../../insights.routes';
import {ActivatedRoute, RouterLink } from '@angular/router';
import { DatePipe, NgClass } from '@angular/common';

@Component({
  selector: 'app-image-report-table',
  templateUrl: './image-report-table.component.html',
  styleUrls: ['./image-report-table.component.scss'],
  imports: [
    MatTable,
    MatSort,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderCellDef,
    MatCell,
    MatCellDef,
    RouterLink,
    DatePipe,
    MatHeaderRow,
    MatRow,
    MatRowDef,
    NgClass,
    MatHeaderRowDef,
  ],
})
export class ImageReportTableComponent {
  selectedRowId: number;

  @ViewChild(MatSort) sort: MatSort;
  @Input() dataSource: MatTableDataSource<ImageWithDriverAndVehicle>;
  @Output() sortChangedEvent: EventEmitter<void> = new EventEmitter();
  @Output() scrolledToBottomEvent: EventEmitter<void> = new EventEmitter();
  @Output() imageSelected: EventEmitter<ImageWithDriverAndVehicle> = new EventEmitter<ImageWithDriverAndVehicle>();

  displayedColumns: string[] = ['shift.id', 'time', 'driver', 'vehicle'];

  InsightsRoute = InsightsRoute;

  constructor(public activatedRoute: ActivatedRoute) {}

  getSort(): string | undefined {
    if (!this.sort.active) {
      return undefined;
    }

    return `${this.sort.active},${this.sort.direction}`;
  }

  onScroll(e) {
    InfiniteScroll.onScroll(e, () => this.scrolledToBottomEvent.emit());
  }

  highlight(image: ImageWithDriverAndVehicle) {
    this.selectedRowId = image.id;
    this.imageSelected.emit(image);
  }
}
